import React from "react";
import { Link, LinkProps, useLocation } from "react-router-dom";

export const LinkWithSearch: React.FC<LinkProps> = ({ to, ...props }) => {
  const { search } = useLocation();
  return <Link {...props} to={to + search} />;
};
